// Where to go after signing in: the page someone was trying to open (a scanned QR code, a bookmarked link) when the
// login stopped them. Only paths inside this app are accepted, so a crafted link cannot send anyone to another site.
const KEY = "return_to";

export const isAppPath = (path) =>
  typeof path === "string" &&
  /^\/(?!\/)[^\s\\]*$/.test(path) &&
  !/^\/(login|register)(\/|\?|$)/.test(path);

export function rememberReturnTo(path) {
  try {
    if (isAppPath(path)) sessionStorage.setItem(KEY, path);
  } catch (e) {
    /* storage can be blocked; signing in then just lands on the home page */
  }
}

// The remembered path (once), or null.
export function takeReturnTo() {
  try {
    const path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return isAppPath(path) ? path : null;
  } catch (e) {
    return null;
  }
}
